enum BadgeColor {
  PRIMARY_OUTLINE = "primary-outline",
  DANGER = "danger",
  WARNING = "warning",
  INFO = "info",
  SUCCESS = "success",
  OFFERED = "offered",
  OPEN = "open",
  OUTLINE = "outline",
  ACTIVE = "active",
  INTERNAL = "internal",
  ADD_TO_COMPANY = "add",
  DRAFT = "draft",
}

export default BadgeColor;
